import React from "react";
import Homeimg from "../Assets/herosectionimg.png";
import LogoImage from "../Assets/logoimage.png";
import Aboutcompany from "../components/aboutcompnay";
import Everydaypractice from "../components/everypractice";
import Question from "../components/questions";
import Businessbox from "../components/bussinessblocks";
import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();
  return (
    <>
      <section className="bg-gradient-to-r from-gray-800 to-gray-900 text-white py-10 ">
        <div className="container mx-auto flex flex-col items-center justify-center px-4">
          <div className="flex flex-col md:flex-row gap-8 md:gap-2 justify-center items-center md:h-[65vh] lg:h-[80vh] xl:h-[80vh]">
            <div className="md:w-1/2  flex justify-start flex-col md:text-start">
              <h1 className="text-3xl md:text-5xl font-bold mt-10 pt-11 md:mt-20">
                Welcome to <span className="text-blue-400">Solace</span> <br />
                Uno
              </h1>
              <p className="text-gray-300 my-4 text-sm md:text-base">
                Voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                Excepteur sint occaecat cupidatat non proident.
              </p>
              <div className="mt-6">
                <a
                  // href="/"
                  onClick={() => {
                    navigate("/signup");
                  }}
                  className="bg-blue-500 text-white px-4 md:px-6 py-2 md:py-3 rounded-lg mr-4 hover:bg-blue-600"
                >
                  Get Started
                </a>
                <a
                  href="/"
                  className="bg-transparent border border-gray-400 text-white px-4 md:px-6 py-2 md:py-3 rounded-lg hover:border-white hover:text-white"
                >
                  Learn More
                </a>
              </div>
            </div>
            <div className="md:w-1/2">
              <img
                src={Homeimg}
                alt="Hero"
                className="w-full h-auto md:w-[532px] md:h-[450px] object-cover"
              />
            </div>
          </div>
          <div className="mt-10 md:mt-0">
            <img
              src={LogoImage}
              alt="Logo"
              className="w-[90%] md:w-[90%] h-auto mx-auto"
            />
          </div>
        </div>
        <section className="py-6">{<Aboutcompany />}</section>
        <section className="py-6">{<Everydaypractice />}</section>
        <section className="py-6">{<Question />}</section>
        <section className="py-6">{<Businessbox />}</section>
      </section>
    </>
  );
}

export default Home;
